<template>
	<div class="open-account-userinfo">

		<h1 class="h1_title">职业/就业情况</h1>

		<van-form @submit="nextStep()" :rules="rules">
			<van-field
				readonly
				clickable
				label="工作状态"
				label-width="80px"
				:value="formItem.working_condition"
				placeholder="请选择"
				@click="show1 = true"
				required
				:rules="rules.working_condition"
			/>
			<van-popup v-model="show1" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr1"
					value-key="name"
					@cancel="show1 = false"
					@confirm="onConfirm1"
				/>
			</van-popup>
			
			<van-field
				readonly
				clickable
				label="业务性质"
				label-width="80px"
				:value="formItem.business_nature"
				placeholder="请选择"
				@click="show2 = true"
				required
				:rules="rules.business_nature"
			/>
			<van-popup v-model="show2" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr2"
					value-key="name"
					@cancel="show2 = false"
					@confirm="onConfirm2"
				/>
			</van-popup>
			<van-field
				v-model="formItem.employer" 
				label="雇主" 
				label-width="80px"
				placeholder="请输入雇主"
				required
				:rules="rules.employer"
			/>
			<van-field
				v-model="formItem.position" 
				label="职位" 
				label-width="80px"
				placeholder="请输入职位"
				required
				:rules="rules.position"
			/>
			<van-field
				readonly
				clickable
				label="任职年限"
				label-width="80px"
				:value="formItem.years_of_employment"
				placeholder="请选择"
				@click="show3 = true"
				required
				:rules="rules.years_of_employment"
			/>
			<van-popup v-model="show3" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr3"
					value-key="name"
					@cancel="show3 = false"
					@confirm="onConfirm3"
				/>
			</van-popup>
			<van-field
				v-model="formItem.employer_address" 
				label="雇主地址" 
				label-width="80px"
				placeholder="请输入雇主地址"
				required
				:rules="rules.employer_address"
			/>
			<!-- <van-field
				readonly
				clickable
				label="是否持牌"
				label-width="80px"
				:value="formItem.has_financial_license"
				placeholder="请选择"
				@click="show5 = true"
				required
				:rules="rules.has_financial_license"
			/>
			<van-popup v-model="show5" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr5"
					@cancel="show5 = false"
					@confirm="onConfirm5"
				/>
			</van-popup> -->
			<div class="van-cell" style="color:#646566;">顾客(或最终实益拥有人)是否任何香港证监会持牌或注册人士的雇员或业务代表？</div>
			<van-radio-group v-model="formItem.has_financial_license" style="padding:16px;background-color: white;">
				<van-radio name="是">是 *请提供持牌或注册人士同意信(如适用)</van-radio>
				<van-radio name="否" style="margin-top: 10px;">否</van-radio>
			</van-radio-group>
			<van-field
				v-model="formItem.registrant" 
				label="持牌或注册人士姓名/名称:(如适用)" 
				label-width="80px"
				placeholder="请输入持牌或注册人士姓名/名称"
				required
				:rules="rules.registrant"
			/>
			<div class="van-cell" style="color:#646566;">持牌或注册人士同意信(如适用)</div>
			<van-row class="label-content">
				<van-col span="12" style="text-align:center;">
					<van-image
						width="150"
						height="100"
						fit="contain"
						:src="license_photo"
						@click="call_bank_front_pic"
					/>
				</van-col>
			</van-row>
			<!-- <van-field
				readonly
				clickable
				label="在公司是否有亲属关系"
				label-width="80px"
				:value="formItem.has_company_kinship"
				placeholder="请选择"
				@click="show6 = true"
				required
				:rules="rules.has_company_kinship"
			/>
			<van-popup v-model="show6" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr6"
					@cancel="show6 = false"
					@confirm="onConfirm6"
				/>
			</van-popup> -->
			<div class="van-cell" style="color:#646566;">顾客(或最终实益拥有人)是否本公司雇员,与本公司之任何雇员或董事有任何亲属关系?</div>
			<van-radio-group v-model="formItem.has_company_kinship" style="padding:16px;background-color: white;">
				<van-radio name="是">是</van-radio>
				<van-radio name="否" style="margin-top: 10px;">否</van-radio>
			</van-radio-group>
			<van-field
				readonly
				clickable
				label="个人税务缴纳"
				label-width="80px"
				:value="formItem.personal_tax_payment"
				placeholder="请选择"
				@click="show4 = true"
				required
				:rules="rules.personal_tax_payment"
			/>
			<van-popup v-model="show4" round position="bottom">
				<van-picker
					title="请选择"
					show-toolbar
					:columns="arr4"
					value-key="name"
					@cancel="show4 = false"
					@confirm="onConfirm4"
				/>
			</van-popup>
			<van-field
				v-model="formItem.tax_region" 
				label="税务地区" 
				label-width="80px"
				placeholder="请输入税务地区"
				required
				:rules="rules.tax_region"
			/>
			<van-field
				v-model="formItem.tax_code" 
				label="税务编号" 
				label-width="80px"
				placeholder="请输入税务编号"
				required
				:rules="rules.tax_code"
			/>
			<div class="common_block">
				<van-button type="warning" block round native-type="submit">{{translate('userinfo_next_step')}}</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
	export default {
		name: 'account_career',
		data() {
			return {
				token: "",
				license_photo: "",
				formItem: {
					working_condition: "",
					business_nature: "",
					years_of_employment: "",
					personal_tax_payment: "",
					employer: "",
					position: "",
					employer_address: "",
					has_financial_license: "",
					license_photo: "",
					has_company_kinship: "",
					tax_region: "",
					tax_code: "",
					registrant: "",
				},

				rules: {
					registrant: [
						{
							required: true,
							message: '请输入持牌或注册人士姓名/名称',
							trigger: 'onBlur'
						}						
					],
					working_condition: [
						{
							required: true,
							message: '请选择工作状态',
							trigger: 'onBlur'
						}						
					],
					business_nature:[
						{
							required: true,
							message: '请选择业务性质',
							trigger: 'onBlur'
						}						
					],
					years_of_employment:[
						{
							required: true,
							message: '请选择任职年限',
							trigger: 'onBlur'
						}						
					],
					personal_tax_payment:[
						{
							required: true,
							message: '请选择个人税务缴纳',
							trigger: 'onBlur'
						}						
					],
					has_financial_license:[
						{
							required: true,
							message: '请选择是否持牌',
							trigger: 'onBlur'
						}						
					],
					has_company_kinship:[
						{
							required: true,
							message: '请选择是否亲属关系',
							trigger: 'onBlur'
						}						
					],
					employer: [
						{
							required: true,
							message: '请输入雇主',
							trigger: 'onBlur'
						}						
					],
					position: [
						{
							required: true,
							message: '请输入职位',
							trigger: 'onBlur'
						}						
					],
					employer_address: [
						{
							required: true,
							message: '请输入雇主地址',
							trigger: 'onBlur'
						}						
					],
					tax_region:[
						{
							required: true,
							message: '请输入税务地区',
							trigger: 'onBlur'
						}						
					],
					tax_code:[
						{
							required: true,
							message: '请输入税务编号',
							trigger: 'onBlur'
						}						
					]
				},
				show1: false,
				arr1: [{name:''}],
				show2: false,
				arr2: [{name:''}],
				show3: false,
				arr3: [{name:''}],
				show4: false,
				arr4: [{name:''}],
				show5: false,
				arr5: ['否', '是'],
				show6: false,
				arr6: ['否', '是'],
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				window.set_bank_front_pic = this.set_bank_front_pic
				this.init()
				this.getquestion(2)
			}
		},
		methods: {
			init(){
				//根据TOKEN获取信息
				this.$axios({
					method: 'post',
					url: 'account_open/info',
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {
						
						if (res.data.status == 2) {
							//	待审核
							this.$router.replace('/account/success')
						} else if (res.data.status == 3) {
							//	不通过
							this.$router.replace('/account/fail?token=' + this.token)
						} else {
							var data = res.data.employment_situation_data		
							if (data.length != 0) {
								this.formItem.working_condition = data.working_condition
								this.formItem.business_nature= data.business_nature
								this.formItem.years_of_employment= data.years_of_employment
								this.formItem.personal_tax_payment= data.personal_tax_payment
								this.formItem.employer= data.employer
								this.formItem.position= data.position
								this.formItem.employer_address= data.employer_address
								this.formItem.has_financial_license= data.has_financial_license
								this.formItem.license_photo= data.license_photo
								this.license_photo= data.license_photo
								this.formItem.has_company_kinship= data.has_company_kinship
								this.formItem.tax_region= data.tax_region
								this.formItem.tax_code= data.tax_code
								this.formItem.registrant= data.registrant
							}
						}
					} else {
						this.$toast.fail(res.error_text)
					}
				})
			},
			call_bank_front_pic(){
                if (window.JsObject != null) {
                    window.JsObject.callBankPic();
                }

                if (window.webkit != null) {
                    window.webkit.messageHandlers.jsToOcWithPrams.postMessage({"camera": "bank_front_pic"});
                }
			},
			set_bank_front_pic(path){

				this.$axios({
					method: 'post',
					url: 'account_open/resize',
					data: {
						img: path
					}
				}).then ((res) => {
					if (res.success) {
						this.license_photo = res.thumb
						this.formItem.license_photo = path
					}else{
						this.$toast.fail('图片上传失败')
					}
				})
			},
			getquestion(type) {
				this.$axios({
					method: 'post',
					url: 'account_open/getquestion',
					data: {
						filter_type:type
					}
				}).then ((res) => {
					if (res.success) {
						this.arr1=res.data[0].answers
						this.arr2=res.data[1].answers
						this.arr3=res.data[2].answers
						this.arr4=res.data[3].answers
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			},
			
			onConfirm1(value) {
				if (value) {
					this.formItem.working_condition = value.name
				}
				
				this.show1 = false
			},
			onConfirm2(value) {
				if (value) {
					this.formItem.business_nature = value.name
				}
				
				this.show2 = false
			},
			onConfirm3(value) {
				if (value) {
					this.formItem.years_of_employment = value.name
				}
				
				this.show3 = false
			},
			onConfirm4(value) {
				if (value) {
					this.formItem.personal_tax_payment = value.name
				}
				
				this.show4 = false
			},
			onConfirm5(value) {
				if (value) {
					this.formItem.has_financial_license = value
				}
				
				this.show5 = false
			},
			onConfirm6(value) {
				if (value) {
					this.formItem.has_company_kinship = value
				}
				
				this.show6 = false
			},
			nextStep() {
				if(this.formItem.has_financial_license == ''){
					this.$toast.fail('请选择是否持牌')
					return false;
				}
				if(this.formItem.has_financial_license == '是' && this.license_photo == ''){
					this.$toast.fail('请上传持牌照片')
					return false;
				}
				if(this.formItem.has_company_kinship == ''){
					this.$toast.fail('请选择是否亲属关系')
					return false;
				}
				this.$axios({
					method: 'post',
					url: 'account_open/alter',
					data: {
						token: this.token,
						employment_situation_data: JSON.stringify(this.formItem)
					}
				}).then ((res) => {
					if (res.success) {
						this.$router.push('/account/finance?token=' + this.token)
					}else{
						this.$toast.fail(res.error_text)
					}
				})
			}
		},
	}
</script>